import {httpService} from "@/modules/common/services";

const getServices = (params) => {
  return httpService.get('platform/v1/scheduling/appointments',params)
}

const fetchServicesCategories = (params) => {
  let getCategoriesParams = {
    business_id: params.business_uid,
    only_visible_services: false,
    categories_array: [],
    has_future_instance: false,
    use_platform_api: true
  }
  return httpService.get('platform/v1/categories', getCategoriesParams)
}

const fetchServicesOfCategory = (params) => {
  return httpService.get(`platform/v1/categories/${params.category_id}/services`, params.category_params)
}

const getAllServicesOfCategory = async (categoryId, businessUid) => {
  let getServicesParams = {
    business_id: businessUid,
    page: 0,
    per_page: 50,
    include_hidden: true,
    only_visible_services: false,
    has_future_instance: false,
    use_platform_api: true,
    extra_decorator_fields: true,
  };
  const params = {category_id: categoryId, category_params: getServicesParams};
  const categoryServicesRes = await fetchServicesOfCategory(params)
  let servicesFullList = categoryServicesRes.data.services
  let nextPage = categoryServicesRes.data.next_page
  while (nextPage && nextPage > 0) {
    getServicesParams.page = nextPage;
    let categoryServicesResPage = await fetchServicesOfCategory(params)
    let extraServices = categoryServicesResPage.data.services
    servicesFullList = servicesFullList.concat(extraServices)
    nextPage = categoryServicesResPage.data.next_page
  }
  return servicesFullList;
}

const updateService = (service_uid, params) => {
  return httpService.put(`settings/services/${service_uid}`, params)
}

export default {
  getServices,
  fetchServicesCategories,
  fetchServicesOfCategory,
  getAllServicesOfCategory,
  updateService,
}
